// import instanceAPIMain from "./mainRequester";
// import http from "./http";
import APIMain from "./http";

export { APIMain };
